export enum AuthenticatorCodeDeliveryMethod {
    NotSelected = 0,
    Application = 1,
    Email = 2
}
